import { Protocols } from '../../../../types/policies';

export const PROTOCOL_TO_DETAILS_MAP: Record<Protocols, string> = {
    [Protocols.KERBEROS_NTLM]: 'Kerberos/NTLM',
    [Protocols.LDAP]: 'LDAP',
    [Protocols.KERBEROS]: 'Kerberos',
    [Protocols.NTLM]: 'NTLM'
};
